import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import { LABELS, WARNINGS, SUCCESS, ERRORS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { GEO_APIs } from "apihandlers/geography";
import { CUSTOMER_APIs } from "apihandlers/customer";

const CustomerForm = (props: any) => {
  const { selectedRow, setManageDialog, setSelectedRow, reloadGrid } = props;

  const customerTypeRef: any = useRef(null);
  const routeRef: any = useRef(null);
  const insertBelowRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [customerType, setCustomerType] = useState<any>([]);
  const [route, setRoute] = useState<any>([]);
  const [insertBelow, setInsertBelow] = useState<any>([]);

  useEffect(() => {
    if (loading) {
      getCustomerTypes();
    }
  }, [loading]);

  const getCustomerTypes = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
      minResponse: true,
    };

    CUSTOMER_APIs.getCustomerTypes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setCustomerType(list);
        getAreas();
      }
    });
  };

  const getAreas = () => {
    const args = {
      minResponse: true,
    };
    GEO_APIs.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setRoute(list);
        getCustomerProfiles();
      }
    });
  };

  const getCustomerProfiles = () => {
    const args = {
      minResponse: true,
    };
    CUSTOMER_APIs.getCustomerProfiles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setInsertBelow(list);
      }
    });
  };

  const manageCustomer = () => {
    const customerTypeId = customerTypeRef.current.selectedValue.id;
    const name = (
      document.getElementById("customerName") as HTMLInputElement
    ).value.trim();
    const address1 = (
      document.getElementById("address1") as HTMLInputElement
    ).value.trim();
    const address2 = (
      document.getElementById("address2") as HTMLInputElement
    ).value.trim();
    const areaId = routeRef.current.selectedValue.id;
    const pincode = (
      document.getElementById("pinCode") as HTMLInputElement
    ).value.trim();
    const incharge = (
      document.getElementById("contactPerson") as HTMLInputElement
    ).value.trim();

    const mobileNumber = (
      document.getElementById("mobileNumber") as HTMLInputElement
    ).value.trim();

    // const insertAbove = (
    //   document.getElementById("insertBelow") as HTMLInputElement
    // ).value.trim();

    const latitude = (
      document.getElementById("latitude") as HTMLInputElement
    ).value.trim();
    const longitude = (
      document.getElementById("longitude") as HTMLInputElement
    ).value.trim();

    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";

    let errors = [];
    if (!customerTypeId) {
      errors.push({
        id: "customerTypeId",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER_TYPE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!name) {
      errors.push({
        id: "customerName",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!address1) {
      errors.push({
        id: "address",
        msg:
          "<span class='bold'>" +
          LABELS.ADDRESS_1 +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!address2) {
      errors.push({
        id: "address2",
        msg:
          "<span class='bold'>" +
          LABELS.ADDRESS_2 +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!areaId) {
      errors.push({
        id: "areaId",
        msg:
          "<span class='bold'>" +
          LABELS.ROUTE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!pincode) {
      errors.push({
        id: "pinCode",
        msg:
          "<span class='bold'>" +
          LABELS.PIN_CODE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!incharge) {
      errors.push({
        id: "contactPerson",
        msg:
          "<span class='bold'>" +
          LABELS.CONTACT_PERSON +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!mobileNumber) {
      errors.push({
        id: "mobileNumber",
        msg:
          "<span class='bold'>" +
          LABELS.MOBILE_NUMBER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      customerTypeId,
      name,
      address1,
      address2,
      areaId,
      pincode,
      incharge,
      mobileNumber,
      insertAbove: 4,
      latitude,
      longitude,
      sortingOrder: 3,
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    CUSTOMER_APIs.manageCustomerProfile(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="flexRowJustify ">
        <div className="formGroup width30 ">
          <label className="red">
            {LABELS.CUSTOMER_TYPE}
            {" *"}
          </label>
          <AutoComplete
            list={customerType}
            childRef={customerTypeRef}
            defaultValue={
              selectedRow.customerTypeId
                ? {
                    id: selectedRow.customerTypeId,
                    label: selectedRow.customerTypeId,
                  }
                : null
            }
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup width30 red">
          <TxtRow
            id={"customerName"}
            type={"text"}
            label={LABELS.CUSTOMER_NAME}
            defaultValue={selectedRow.name}
            disabled={isSubmit}
            required={true}
          />
        </div>
        <div className="formGroup width30 red">
          <TxtRow
            id={"address1"}
            type={"text"}
            label={LABELS.ADDRESS_1}
            defaultValue={selectedRow.address1}
            disabled={isSubmit}
            required={true}
          />
        </div>
      </div>
      <div className="flexRowJustify ">
        <div className="formGroup width30 red">
          <TxtRow
            id={"address2"}
            type={"text"}
            label={LABELS.ADDRESS_2}
            defaultValue={selectedRow.address2}
            disabled={isSubmit}
            required={true}
          />
        </div>
        <div className="formGroup width30 ">
          <label className="red">
            {LABELS.ROUTE}
            {" *"}
          </label>

          <AutoComplete
            list={route}
            childRef={routeRef}
            defaultValue={
              selectedRow.areaId
                ? {
                    id: selectedRow.areaId,
                    label: selectedRow.areaName,
                  }
                : null
            }
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup width30 red">
          <TxtRow
            id={"pinCode"}
            type={"number"}
            label={LABELS.PIN_CODE}
            defaultValue={
              selectedRow.pincode
                ? Number(selectedRow.pincode).toString()
                : selectedRow.pincode
            }
            disabled={isSubmit}
            required={true}
          />
        </div>
      </div>
      <div className="flexRowJustify">
        <div className="formGroup width30 red">
          <TxtRow
            id={"contactPerson"}
            type={"text"}
            label={LABELS.CONTACT_PERSON}
            defaultValue={selectedRow.incharge}
            disabled={isSubmit}
            required={true}
          />
        </div>
        <div className="formGroup width30 red">
          <TxtRow
            id={"mobileNumber"}
            type={"number"}
            label={LABELS.MOBILE_NUMBER}
            defaultValue={
              selectedRow.mobileNumber
                ? Number(selectedRow.mobileNumber).toString()
                : selectedRow.mobileNumber
            }
            required={true}
          />
        </div>
        <div className="formGroup width30 ">
          <label>{LABELS.INSERT_BELOW}</label>

          <AutoComplete
            list={insertBelow}
            childRef={insertBelowRef}
            defaultValue={
              selectedRow.countryId
                ? {
                    id: selectedRow.countryId,
                    label: selectedRow.country,
                  }
                : null
            }
            disabled={isSubmit}
          />
        </div>
      </div>
      <div className="flexRowJustify">
        <div className="formGroup width30 ">
          <TxtRow
            id={"latitude"}
            type={"number"}
            label={LABELS.LATITUDE}
            disabled={isSubmit}
            defaultValue={
              selectedRow.latitude
                ? Number(selectedRow.latitude).toString()
                : selectedRow.latitude
            }
          />
        </div>
        <div className="formGroup width30 ">
          <TxtRow
            id={"longitude"}
            type={"number"}
            label={LABELS.LONGITUDE}
            defaultValue={
              selectedRow.longitude
                ? Number(selectedRow.longitude).toString()
                : selectedRow.longitude
            }
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup width30 required ">
          <label>
            {LABELS.STATUS}
            {/* {<span className="red">*</span>} */}
          </label>
          <RadioBtn
            list={[
              {
                id: "true",
                value: "true",
                label: LABELS.ACTIVE,
                checked: selectedRow.id
                  ? selectedRow.activeStatus === true
                  : true,
                disabled: false,
              },
              {
                id: "false",
                value: "false",
                label: LABELS.INACTIVE,
                checked: selectedRow.id
                  ? selectedRow.activeStatus === false
                  : false,
                disabled: false,
              },
            ]}
            row={true}
            name={"activeStatus"}
            disabled={isSubmit}
          />
        </div>
      </div>

      {/* mandatoryResults */}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="formGroup submitBtnWrapper">
        <div className="flexbtnjustify">
          <Btn
            text={LABELS.CANCEL}
            loading={isSubmit}
            bgColor={COLORS.RELOAD_EXPORT}
            color={COLORS.RELOAD_EXPORT_TEXT}
            onClick={() => {
              setManageDialog(false);
              setMandatoryResults([]);
            }}
          />
          <Btn
            text={LABELS.SAVE}
            loading={isSubmit}
            bgColor={COLORS.SAVE_GREEN}
            onClick={manageCustomer}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(CustomerForm);
